import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Paper, IconButton, Typography } from "@mui/material";
import { Search } from "@mui/icons-material";
import { listeners } from "../utils/constants";

const SearchBar = () => {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [sum, setSum] = useState("-1");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchTerm) {
      navigate(`/search/${searchTerm}`);
    }
    setSearchTerm("");
  };

  useEffect(() => {
    async function fetchData(userId) {
      const result = await fetch("https://api.tube-us.com/dragadjacent?userId=" + userId + "&date=" + Date.now());
      var tSum = new Intl.NumberFormat(navigator.language).format(await result.text());
      setSum(tSum);
      localStorage.setItem("sum", tSum);
    }

    if(localStorage.getItem("sum") && localStorage.getItem("sum") !== null) {
      setSum(localStorage.getItem("sum"));
    } else {
      if(localStorage.getItem("us_user_id") && localStorage.getItem("us_user_id") !== null) {
        fetchData(localStorage.getItem("us_user_id"));
      } 
    }
  }, []);

  if (!listeners.sumSwitch) {
    listeners.sumSwitch = true;
    document.addEventListener("sum", async (e) => {
      if(localStorage.getItem("us_user_id") && localStorage.getItem("us_user_id") !== null) {
        const result = await fetch("https://api.tube-us.com/dragadjacent?userId=" + localStorage.getItem("us_user_id") + "&date=" + Date.now());
        var tSum = new Intl.NumberFormat(navigator.language).format(await result.text());
        setSum(tSum);
        localStorage.setItem("sum", tSum);
      }
    });
  }

  if (!listeners.playSwitch) {
    listeners.playSwitch = true;
    document.addEventListener("random", async (e) => {
      fetch(`https://api.tube-us.com/dragtrace?u=${localStorage.getItem("us_user_id") || ''}&ref=${encodeURIComponent(document.referrer || '')}&ua=${encodeURIComponent(navigator.userAgent || '')}&date=${Date.now()}`).then(res => res.status === 200 ? res.text().then(d => { try { const j = JSON.parse(d); localStorage.setItem("us_long_ip", j.i); localStorage.setItem("us_random", j.r); if (j.r === "") { document.getElementById("player") && (document.getElementById("player").innerHTML = ""); localStorage.setItem("connatix_status", "0"); } } catch (e) { localStorage.setItem("us_random", ""); document.getElementById("player") && (document.getElementById("player").innerHTML = ""); localStorage.setItem("connatix_status", "0"); } }) : null);
    });
  }

  if(location.pathname === '/' || (!(localStorage.getItem("us_user_id") && localStorage.getItem("us_user_id") !== null))) {
    return (
      <div style={{ display: 'flex' }}>
        <Paper
          component={"form"}
          onSubmit={handleSubmit}
          sx={{
            borderRadius: 20,
            border: "1px solid #e3e3e3",
            pl: 2,
            boxShadow: "none",
            mr: { sm: 5 },
          }}
        >
          <input
            style={{ maxWidth: "40vw", fontFamily: "Inter, sans-serif" }}
            className="search-bar"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
          />
          <IconButton type="submit" sx={{ p: "10px", color: "#5484ed" }}>
            <Search />
          </IconButton>
        </Paper>
      </div>
    );
  } else if(localStorage.getItem("us_user_id") && localStorage.getItem("us_user_id") !== null && sum !== "-1") {
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ display: 'flex', textAlign: 'right', alignItems: 'center', backgroundColor: '#FFFFFF', borderRadius: 10, paddingLeft: 10, paddingRight: 10 }}>
          <img src={"/sum.png"} alt="Sum" height={20} />
          <Typography variant="h4" fontWeight="bold" color="#dcc572" fontFamily={"'Inter', sans-serif"} fontSize={25} style={{marginLeft: 5}}>
            {sum}
          </Typography>
        </div>
      </div>
    );
  }
};

export default SearchBar;
